var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiyalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20943_41912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4488 22.4893C16.0919 23.2682 15.856 24.1134 15.7656 24.9998L23.3182 23.4197C23.6751 22.641 23.9109 21.7956 24.0014 20.9092L16.4488 22.4893Z",
    fill: "#23242A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3168 18.6859C23.6737 17.9072 23.9096 17.0618 24 16.1754L18.1167 17.4069V15.0395L23.3166 13.9519C23.6735 13.1732 23.9094 12.3278 23.9998 11.4415L18.1166 12.6719V4.15797C17.2151 4.65614 16.4145 5.31926 15.7637 6.10146V13.1643L13.4107 13.6565V3C12.5093 3.498 11.7086 4.1613 11.0578 4.94349V14.1486L5.79319 15.2496C5.4363 16.0283 5.20021 16.8737 5.10965 17.7601L11.0578 16.516V19.4973L4.68319 20.8306C4.32629 21.6093 4.09038 22.4547 4 23.3411L10.6725 21.9455C11.2156 21.8343 11.6825 21.5182 11.986 21.0833L13.2097 19.2977V19.2974C13.3367 19.1126 13.4107 18.8899 13.4107 18.65V16.0238L15.7637 15.5316V20.2664L23.3166 18.6855L23.3168 18.6859Z",
    fill: "#23242A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20943_41912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyalIcon);
export default __webpack_public_path__ + "static/media/riyal-icon.0a359709d487b3b27a9fea6103b0fea0.svg";
export { ForwardRef as ReactComponent };